<template>
    <div>
        <datatable :columns="columns" :source="getRecords" :datachanged="carehomeid" :suppressrowselected="true"></datatable>
    </div>
</template>


<script >
    import datatable from "../../corecontrols/datatable/datatable.scp.html";
    import { CarehomeDto } from './../../../dto/carehomedto'
    import { WardDto } from './../../../dto/WardDto'
    import Dal from './../../../scripts/dataaccess'
    import Formatter from "../../corecontrols/formatters/Formatter"
    
    export default  {
        props: ['carehomeid'],
        data: function () {
            return {
                columns: [
                    {
                        name: "Name", data: "name"                        
                    },
                    {
                        name: "Notes", data: "notes"
                    }
                ]
            }
        },
        mounted: function () {
            console.log("patient list mounted with id " + this.carehomeid)
            
        },
        methods: {

            getRecords: function (callback) {
                var dal = new Dal();
                dal.GetWards(this.carehomeid).then(data => {
                    var records = { data: data };
                    callback(records);
                });
            },

            recordSelected: function (record) {
                var id = record.id;
               
            }
        },
        components: {
            datatable
        }
    }
</script>


// WEBPACK FOOTER //
// carehome-ward-list.scp.html?386432ea